export const convertArrayToCSV = (arr: any[]) => {
    if (arr.length === 0) return "";
    const array = [Object.keys(arr[0])].concat(arr);

    return array
        .map((it) => {
            return Object.values(it).reduce((acc, curr) => {
                acc += curr + "\t";
                return acc;
            }, "");
        })
        .join("\n");
};
